module.exports = __webpack_public_path__ + "img/slolution-4.470b81c.png";